import { Component, EventEmitter, Input, OnInit, Output, Host, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { PhotoPosition } from '../../../models/trofaco/plantingSiteDetailDto';
import { BaseComponent } from '../../core/components/bases/base-component';
import { CanDeactivateService } from '../../core/services/can-deactivate.service';
import { NgForm } from '@angular/forms';
declare var loadImage: any; 

export interface FileHandle {
    file: File,
    url: SafeUrl
}
@Component({
    selector: 'app-photo-upload',
    templateUrl: './photo-upload.component.html',
    styleUrls: ['./photo-upload.component.css']
})
export class PhotoUploadComponent extends BaseComponent implements OnInit, AfterViewInit {

    @ViewChild('imageContainer', {static: false}) imageContainer: ElementRef<HTMLDivElement>;

    @ViewChild('existingImage', {static: false}) existingImage: ElementRef<HTMLDivElement>;

    positionEnum = PhotoPosition;
    position = 1;

    @Input()
    backgroundSize: 'contain' | 'cover' | 'auto' | string = 'cover';
    
    private oldCanvas: HTMLCanvasElement;
    private uploadImageClass = 'upload-file-image';

    @Input() set photoPosition(value: PhotoPosition) {
        this.position = value;
        if (this.hasPriviewImage) {
            this.existingImage.nativeElement.className = this.getUploadImageContainerClass(value);
        }else if(!!this.oldCanvas){
            this.oldCanvas.className = this.getUploadImageContainerClass(value);
        }
    }

    get hasPriviewImage(): boolean{
        return !!this.existingPhotoUrl;
    }

    @Input()
    showRemove = false;

    @Input()
    isDisabled = false;

    @Input()
    existingPhotoUrl: string;

    @Output() photoSelected = new EventEmitter<File>();

    @Output() removeImage = new EventEmitter();

    file: FileHandle;

    constructor(@Host() private form: NgForm, 
        private canDeactivateService: CanDeactivateService, 
        private renderer: Renderer2) {
        super();
    }

    ngOnInit() {
        this.canDeactivateService.registerCanDeactivate(() => !this.hasUnsavedData, this.onDestroy$);
    }

    ngAfterViewInit(){
        if (this.existingPhotoUrl) {
            this.existingImage.nativeElement.className = this.getUploadImageContainerClass(this.position);
        }
    }

    filesSelected(fileList: FileList) {
        if (fileList.length < 1) return;
        let file = fileList[0];
        const url = window.URL.createObjectURL(file);
        this.file = {file, url};

        let options = {
            pixelRatio: window.devicePixelRatio,
            downsamplingRatio: 0.5,
            orientation: true
        }

        this.position = 1;
        
        loadImage(file, (canvas: HTMLCanvasElement) => {
            if (!!this.oldCanvas) {
                this.renderer.removeChild(this.imageContainer.nativeElement, this.oldCanvas);
            }
            
            canvas.className = this.getUploadImageContainerClass();
            this.oldCanvas = canvas;

            this.renderer.appendChild(this.imageContainer.nativeElement, canvas);
            this.existingPhotoUrl = '';
        }, options);

        this.photoSelected.emit(file);
        this.form.control.markAsDirty();
    }

    getUploadImageContainerClass(position: number = 1){
        if (position == 1) return `${this.uploadImageClass} top`;
        else if (position == 2) return `${this.uploadImageClass} middle`;
        return `${this.uploadImageClass} bottom`;
    }

    removeImages() {
        this.file = null;
        this.existingPhotoUrl = '';
        this.removeImage.emit();
        this.form.control.markAsDirty();
    }

    get hasUnsavedData(): boolean { // return true to show warn promt
        // leaving pristinly
        if(!this.form.submitted && !this.form.dirty){
            return false;
        } 
        // submit
        else if(this.form.submitted){
            return false;
        }
        // leaving with dirty form
        return true;
    }
}
